
var RootView = Marionette.View.extend({
	template: _.template($("#tmpl-site-root").html()),
	className:"mainDiv",
	regions: function(){
		return {
			mainRegion	 	: "#main-region"
			,dialogRegion	: "#dialog-region"			
		};
	}
});

var APP = new Marionette.Application({
     region:'#root'
    //could also use APP.on("start",function(){})
    ,onStart: function(){
        console.log("APP Start")
        this.showView(new RootView())
        
         if(!Backbone.history.start({pushState: true})){
            //throw a 404 if you want
//             Backbone.Radio.channel('404').request("show");
        }

    }
});

